export enum EInvoiceAddressSchemeType {
  OVT = 'OVT',
  VAT = 'VAT',
  ORGNR = 'ORGNR',
  GLN = 'GLN',
  DUNS = 'DUNS',
  IBAN = 'IBAN',
  OIN = 'OIN',
  OINO = 'OINO',
  SIRENE = 'SIRENE',
  KUR = 'KUR',
  GOV = 'GOV',
  LWID = 'LWID',
  CUSTOM = 'CUSTOM',
}
